<template>
    <v-container class="my-5">
        <!--     Diálogo Modal Persistente para Recortar Logotipo del Fraccionamiento      -->
        <v-dialog v-model="dialogImageLogo" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            mode="normal"
                            class="basic lg"
                            ref="clipperImageLogo"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="getCutingLogo()"
                    >{{$t('recortar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Registro del Directorio     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_eliminar_directory')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteDirectory()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">Staff</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="550">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                color="primary"
                                v-on="on"
                                @click="update = false, getAreas() ,cleanFields()"
                        >
                            + {{$t('add_directory')}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-form
                        @submit.prevent="update
                            ? updateDirectory(idUpdate)
                            : addStaff()"
                >
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                Staff
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false"
                            ><v-icon>mdi-close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="6" md="6">
                                    <v-autocomplete
                                            v-if="dialog" autofocus
                                            v-model="idArea"
                                            prepend-icon="mdi-domain"
                                            name="idArea"
                                            item-text="name"
                                            item-value="id"
                                            :label="$t('Area')"
                                            :placeholder="$t('choose_category')"
                                            :error-messages="errores.idArea"
                                            :items="areas"
                                            no-data-text="Ningún Resultado"
                                            clearable
                                            autocomplete="off"
                                    >
                                    </v-autocomplete>
                                    <v-text-field
                                            v-model="fullName"
                                            name="fullName"
                                            prepend-icon="mdi-account"
                                            :label="$t('full_name')"
                                            counter
                                            maxlength="200"
                                            :error-messages="errores.fullName"
                                    ></v-text-field>
                                    <v-text-field
                                            v-model="position"
                                            name="position"
                                            prepend-icon="mdi-sitemap"
                                            :label="$t('position')"
                                            counter
                                            maxlength="100"
                                            :error-messages="errores.position"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="6">
                                    <v-flex xs12 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_perfil')}}
                                    </v-label>
                                    <br>
                                    <v-img
                                        class="pt-3 pb-3"
                                        :src="resultLogoURL"
                                        v-if="resultLogoURL"
                                        width="auto"
                                        height="auto"
                                    ></v-img>
                                    <br>
                                    <v-btn
                                        color="primary">
                                        <clipper-upload
                                            @input="dialog = false, dialogImageLogo = true"
                                            accept="image/*"
                                            v-model="imageFrontURL"
                                        >
                                        {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
                                    <v-alert
                                        v-if="errores.avatar"
                                        type="error"
                                        outlined
                                        transition="scale-transition"
                                    >
                                        {{errores.avatar}}
                                    </v-alert>
                                    </v-flex>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                            <v-spacer/>
                            <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                            <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    Staff
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            clearable
                            append-icon="mdi-magnify"
                            :label="$t('search_by_name')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loadingDataStaff"
                        :items="staffs"
                        multi-sort
                        :search="search"
                        :footer-props="{
                            itemsPerPageOptions: [
                                {text: '5', value: 5},
                                {text: '10', value: 10},
                                {text: '25', value: 25},
                                {text: this.$t('todos'), value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                        :no-data-text="$t('no_records_yet')"
                        class="elevation-1"
                >
                    <template v-slot:item.inhabited="{ item }">
                        <v-icon
                                v-if="item.inhabited === true"
                                medium
                                color="primary"
                                class="mr-2"
                        >
                            mdi-check
                        </v-icon>
                        <v-icon
                                v-if="item.inhabited === false"
                                medium
                                color="red"
                                class="mr-2"
                        >
                            mdi-close
                        </v-icon>
                        {{ item.inhabited ? $t('habitada') : $t('deshabitada') }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="gray"
                                        class="mr-2"
                                        @click="fillFields(item), update = true, dialog = true, idUpdate = item.id"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>{{$t('change')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="red"
                                        class="mr-2"
                                        @click="deleteDialog = true, idDirectoryDelete = item.id"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>{{$t('delete')}}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:item.phone="{ item }">
                        <div>
                            {{item.phone}}
                        </div>
                        <div>
                            {{item.phone2}}
                        </div>
                        <div>
                            {{item.phone3}}
                        </div>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'directory',
  created () {
    this.getStaff()
    this.getAreas()
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language'])
  },
  data: () => ({
    dialog: false,
    idHouse: '',
    fullName: '',
    position: '',
    fullNameAux: '',
    positionAux: '',
    header: [],
    loadingDataStaff: false,
    loading: false,
    areas: [],
    idArea: '',
    staffs: [],
    search: '',
    update: false,
    errores: [],
    errorsPhone: [],
    idUpdate: 0,
    idDirectoryDelete: 0,
    deleteDialog: false,
    dialogImageLogo: false,
    file: null,
    rules: [
      value => !value || value.type === 'application/vnd.ms-excel' || 'Archivo con formato incorrecto.'
    ],
    headers: [],
    resultLogoURL: '',
    imageFrontURL: ''
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        sortable: false,
        value: 'action'
      },
      {
        text: this.$t('Area'),
        align: 'center',
        sortable: true,
        value: 'areaName'
      },
      {
        text: this.$t('full_name'),
        align: 'center',
        sortable: true,
        value: 'fullName'
      },
      {
        text: this.$t('position'),
        align: 'center',
        sortable: true,
        value: 'position'
      }
    ]
  },
  methods: {
    getStaff () {
      this.loadingDataStaff = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/staff/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.staffs = response.data
          this.loadingDataStaff = false
        })
        .catch(error => {
          this.loadingDataStaff = false
          console.log(error)
        })
    },
    getAreas () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/area/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.areas = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    addStaff () {
      this.loading = true
      this.errores = []
      const newID = this.$uuid.v4()
      var bodyFormData = new FormData()
      var fileImageFront = null

      bodyFormData.set('idArea', this.idArea)
      bodyFormData.set('fullName', this.fullName)
      bodyFormData.set('position', this.position)
      bodyFormData.set('idHousingUnit', this.getProfile.idHousingUnit)
      if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
        fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'avatar' + newID + '.jpeg')
      }
      bodyFormData.append('avatar', fileImageFront)
      const config = {
        method: 'post',
        url: 'https://clubtest.intrare.app/staff/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_directory_alta'))
          this.dialog = false
          this.getStaff()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
              console.log(this.errores.phone2)
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    updateDirectory (id) {
      this.loading = true
      this.errores = []
      this.errorsPhone = []

      var bodyFormData = new FormData()
      var fileImageFront = null

      if (this.fullName !== this.fullNameAux) {
        bodyFormData.set('fullName', this.fullName)
      }
      if (this.position !== this.positionAux) {
        bodyFormData.set('position', this.position)
      }
      bodyFormData.set('idArea', this.idArea)
      if (this.resultLogoURL !== this.resultAuxLogoURL) {
        const newID = this.$uuid.v4()
        if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'avatar_update' + newID + '.jpeg')
        }
        bodyFormData.append('avatar', fileImageFront)
      }
      const config = {
        method: 'patch',
        url: 'https://clubtest.intrare.app/staff/' + id,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getStaff()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_directory_modificado'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    deleteDirectory () {
      const config = {
        method: 'delete',
        url: ' https://clubtest.intrare.app/staff/' + this.idDirectoryDelete,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Registro con ID = ', this.idDirectoryDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_directory_eliminada'))
        this.getStaff()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    getCutingLogo () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageLogo.clip() // call component's clip method
      this.resultLogoURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultLogoURL)
      this.dialogImageLogo = false
      this.dialog = true
    },
    cleanFields () {
      this.idArea = ''
      this.fullName = ''
      this.position = ''
      this.resultLogoURL = ''
      this.resultAuxLogoURL = ''
    },
    fillFields (item) {
      this.fullName = item.fullName
      this.position = item.position
      this.fullNameAux = item.fullName
      this.positionAux = item.position
      this.resultLogoURL = item.avatar
      this.resultAuxLogoURL = item.avatar
      this.idArea = item.idArea
    },
    clear: function () {
      this.errores = []
      this.errorsPhone = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style scoped>
.edge {
    border-radius: 8px;
    border-color: #2a2738 #2a2738 #2a2738 #2a2738;
    border-width: 3px 3px 3px 3px;
    text-align: center;
    border-style: solid solid solid solid;
}
</style>
